module.exports = __webpack_public_path__ + "static/img/ptld_4@2x.341e68ad.png";